type NamedSalesItem = {
  name: string;
};

export const dedupeSalesItemsByPublicName = <T extends NamedSalesItem>(items: T[]): T[] => {
  const seen = new Set<string>();
  const result: T[] = [];

  for (const item of items) {
    const key = item.name.trim().toLowerCase();
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    result.push(item);
  }

  return result;
};
